import { useEffect, useState } from 'react';

import { JiraConnectAPI } from '../JiraConnect.interface';

function getConnect() {
  return typeof window.AP?.request === 'function'
    ? (window.AP as JiraConnectAPI)
    : undefined;
}

// non-hook implementation
export function getJiraConnect() {
  let stop = false;
  const abort = () => {
    stop = true;
  };
  const getAsync = async (maxAttempts = 2) => {
    let attempt = 1;
    do {
      const connect = getConnect();
      if (connect) {
        return connect;
      }
      console.debug(
        '[jira-connect] Attempt: %o Exists: %o',
        attempt++,
        !!connect
      );
      // wait before attempting next iteration
      await new Promise(resolve => setTimeout(resolve, 200));
    } while (!stop && attempt <= maxAttempts);
    console.warn('[jira-connect] JIRA Connect API is not available.');
  };
  return { abort, get: getConnect, getAsync };
}

export function useGetJiraConnect(maxAttempts = 5) {
  const connectState = useState(() => getConnect());
  const [connect, setConnect] = connectState;
  const hasConnect = !!connect;

  useEffect(() => {
    if (hasConnect) {
      return;
    }
    const { abort, getAsync } = getJiraConnect();
    getAsync(maxAttempts).then(connect => connect && setConnect(connect));
    return abort;
  }, [hasConnect, maxAttempts, setConnect]);

  return connect;
}
